// Centralized helpers for booking status display

const STATUS_MAP = {
  PENDING_PAYMENT: { label: "Pending payment", badgeClass: "bg-amber-100 text-amber-800" },
  PENDING: { label: "Pending", badgeClass: "bg-yellow-100 text-yellow-800" },
  CHECKED_IN: { label: "Checked in", badgeClass: "bg-blue-100 text-blue-800" },
  COMPLETED: { label: "Completed", badgeClass: "bg-green-100 text-green-800" },
  CANCELLED: { label: "Cancelled", badgeClass: "bg-red-100 text-red-800" },
  CANCELED: { label: "Cancelled", badgeClass: "bg-red-100 text-red-800" },
  NO_SHOW: { label: "No show", badgeClass: "bg-orange-100 text-orange-800" },
};

export const getBookingStatusLabel = status => {
  if (!status) return "Unknown";
  const normalized = String(status).toUpperCase();
  if (STATUS_MAP[normalized]) return STATUS_MAP[normalized].label;
  return normalized.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
};

export const getBookingStatusBadgeClass = status => {
  if (!status) return "bg-gray-100 text-gray-700";
  const normalized = String(status).toUpperCase();
  if (STATUS_MAP[normalized]) return STATUS_MAP[normalized].badgeClass;
  return "bg-gray-100 text-gray-700";
};
